import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type CellProps = ComponentProps<'td'>;

function Cell({ className, children, ...props }: CellProps) {
  return (
    <td className={twMerge('py-3 px-4 paragraph-explanatory', className)} {...props}>
      {children}
    </td>
  );
}

export { Cell };
